import _ from 'lodash';
import React from 'react';
import ConfigUI from './configui';
export default class ConfigUIC extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            config: props.config,
        };
    }
    componentDidMount() {
        this._changeVisible(true);
    }
    _changeVisible(v) {
        const { visible } = this.state;
        if (visible !== v) {
            this.setState({
                visible: v
            });
        }
    }
    open(config) {
        // console.log(_.isEqual(config, this.state.config));
        if (!_.isEqual(config, this.state.config)) {
            this.setState({ config });
        }
        this._changeVisible(true);
    }
    show() {
        this._changeVisible(true);
    }
    close() {
        this._changeVisible(false);
    }
    render() {
        const { formatMessage } = this.props;
        const { visible, config } = this.state;
        const props = {
            config,
            visible,
            formatMessage,
            onCancel: this.close.bind(this)
        };
        return (React.createElement(ConfigUI, Object.assign({}, props)));
    }
}
